import React from 'react';
import { Card, Image, Table } from 'antd';
import type { TableProps } from 'antd';
import EnumKeyToText from './enumkeyTotext';
import { jsonParseData } from '../../../../utils';
import _ from 'lodash';

interface RefundStatusPropsType {
	data?: any;
	enums?: any;
}

const RefundStatus: React.FC<RefundStatusPropsType> = props => {
	const { data, enums } = props;

	return <EnumKeyToText data={data} enums={enums} valueKey={'refund_status'} nameSpace={'order_refund_status'} />;
};

interface EvidencePropsType {
	data?: any;
}

const Evidence: React.FC<EvidencePropsType> = props => {
	const { data } = props;
	const arr = jsonParseData(data, []);
	if (Array.isArray(arr) && arr.length) {
		return (
			<div style={{ display: 'flex' }}>
				{arr.map((item: any) => (
					<div style={{ marginRight: '10px' }}>
						<Image width={60} height={60} src={item} />
					</div>
				))}
			</div>
		);
	}
	return null;
};

interface PropsType {
	enums?: any;
	data?: any;
	changePriceFormat?: any;
}

interface TableDataType {
	id: number;
	username?: string;
	cell_encrypt?: string;
	user_status?: number;
	role_list?: any;
	store_list?: any;
	create_time?: string;
	update_time?: string;
	refund_type?: any;
}

const RefundDetails: React.FC<PropsType> = props => {
	const { data, enums, changePriceFormat } = props;

	const columns: TableProps<TableDataType>['columns'] = [
		{ title: '退款日期', dataIndex: 'refund_time', key: 'refund_time' },
		{
			title: '退款原因',
			dataIndex: 'refund_type',
			key: 'refund_type',
			render: (text, record) => _.find(enums.order_refund_type, ['key', record.refund_type])?.value,
		},
		{
			title: '退款说明',
			dataIndex: 'reason',
			key: 'reason',
		},
		{
			title: '退款状态',
			dataIndex: 'refund_status',
			key: 'refund_status',
			render: (_, record) => <RefundStatus data={record} enums={enums} />,
		},
		{
			title: '退款金额',
			dataIndex: 'amount',
			key: 'amount',
			render: text => changePriceFormat(text),
		},
		{
			title: '退款凭证',
			dataIndex: 'evidence',
			key: 'evidence',
			render: text => <Evidence data={text} />,
		},
		{
			title: '操作人',
			dataIndex: 'operator',
			key: 'operator',
		},
	];

	return (
		<Card title="退款明细" style={{ marginTop: '20px' }}>
			<Table columns={columns} dataSource={data?.refund_items} rowKey={cols => cols.id} pagination={false} />
		</Card>
	);
};

export default RefundDetails;
